
/**
 * Various methods for object operations
 *
 * @export
 * @abstract
 * @class ObjectHelper
 */
export abstract class ObjectHelper {

    /**
     * Returns true if an object has no properties (eg: var o = {} )
     *
     * @static
     * @param {object} object
     * @returns {boolean}
     * @memberof ObjectHelper
     */
    public static hasAnyProp(object: object): boolean {
        for (const prop in object) {
            if (object.hasOwnProperty(prop)) {
                return true;
            }
        }
        return false;
    }
}
